import { useRef } from "react";
export const useDebounce = (callback, delay = 800) => {
  const timer = useRef(null);

  return (...args) => {
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};
